
const PlanSection = () => {
  return (
    <section className="py-20 bg-[#2c5f7c] relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            料金表
          </h2>
          <p className="text-xl text-white/90">
            Pricing
          </p>
        </div>

        {/* Pricing Grid */}
        <div className="max-w-6xl mx-auto">
          {/* Implant Base Price */}
          <div className="bg-white rounded-2xl p-8 shadow-xl mb-8">
            <div className="text-center mb-6">
              <h3 className="text-3xl font-bold text-[#2c5f7c] mb-4">
                インプラント基本料金
              </h3>
              <div className="text-6xl font-bold text-[#c8a882] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                25万円
              </div>
              <p className="text-lg text-gray-600">（税込）/ 1本</p>
            </div>
            <div className="text-center text-[#2c5f7c] font-semibold">
              オペ・骨造成(GBR)込みの金額です。
            </div>
          </div>

          {/* Crown Options */}
          <div className="bg-white rounded-2xl p-8 shadow-xl">
            <div className="text-center mb-8">
              <h3 className="text-3xl font-bold text-[#2c5f7c] mb-4">
                上部構造（クラウン）
              </h3>
              <p className="text-lg text-gray-600">
                お好みに合わせてお選びいただけます
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Zirconia */}
              <div className="bg-gradient-to-br from-[#c8a882] to-[#b89872] rounded-xl p-6 text-white relative overflow-hidden">
                <div className="absolute top-3 right-3">
                  <div className="bg-white text-[#c8a882] px-3 py-1 rounded-full text-xs font-bold">
                    おすすめ
                  </div>
                </div>
                <div className="text-center">
                  <h4 className="text-lg font-bold mb-3">ジルコニア</h4>
                  <div className="text-3xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                    13万円
                  </div>
                  <p className="text-sm text-white/90">（税込）</p>
                  <div className="mt-4 text-sm">
                    最高品質・自然な仕上がり
                  </div>
                </div>
              </div>

              {/* Gold */}
              <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl p-6 text-white">
                <div className="text-center">
                  <h4 className="text-lg font-bold mb-3">金</h4>
                  <div className="text-3xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                    10万円
                  </div>
                  <p className="text-sm text-white/90">（税込）</p>
                  <div className="mt-4 text-sm">
                    耐久性抜群・生体親和性
                  </div>
                </div>
              </div>

              {/* Silver */}
              <div className="bg-gradient-to-br from-gray-400 to-gray-500 rounded-xl p-6 text-white">
                <div className="text-center">
                  <h4 className="text-lg font-bold mb-3">銀</h4>
                  <div className="text-3xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                    8万円
                  </div>
                  <p className="text-sm text-white/90">（税込）</p>
                  <div className="mt-4 text-sm">
                    コストパフォーマンス良好
                  </div>
                </div>
              </div>

              {/* Plastic */}
              <div className="bg-gradient-to-br from-blue-400 to-blue-500 rounded-xl p-6 text-white">
                <div className="text-center">
                  <h4 className="text-lg font-bold mb-3">プラスチック</h4>
                  <div className="text-3xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                    3万円
                  </div>
                  <p className="text-sm text-white/90">（税込）</p>
                  <div className="mt-4 text-sm">
                    経済的・軽量
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Total Example */}
          <div className="mt-8 bg-[#f5f1e8] rounded-2xl p-8 border-2 border-[#c8a882]">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-[#2c5f7c] mb-4">
                料金例
              </h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-lg p-4">
                  <div className="text-lg font-semibold text-[#2c5f7c] mb-2">
                    インプラント + ジルコニア
                  </div>
                  <div className="text-3xl font-bold text-[#c8a882]">
                    38万円
                  </div>
                  <div className="text-sm text-gray-600">（25万円 + 13万円）</div>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <div className="text-lg font-semibold text-[#2c5f7c] mb-2">
                    インプラント + 金
                  </div>
                  <div className="text-3xl font-bold text-[#c8a882]">
                    35万円
                  </div>
                  <div className="text-sm text-gray-600">（25万円 + 10万円）</div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                サイナスフロアエレベーション
              </h3>
              <p className="text-white/90 text-center mb-6">
                上顎臼歯の骨が少ない方への骨造成となります。治療費は別途頂戴いたします。
              </p>
              
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4 text-center">
                  <div className="font-semibold text-[#2c5f7c] mb-2">パーティカルアプローチ(垂直)</div>
                  <div className="text-3xl font-bold text-[#c8a882]">6万円</div>
                </div>
                <div className="bg-white rounded-lg p-4 text-center">
                  <div className="font-semibold text-[#2c5f7c] mb-2">ラテラルアプローチ(側方)</div>
                  <div className="text-3xl font-bold text-[#c8a882]">12万円</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlanSection;
